// guided-make-uploads-chrome — the Images & sounds (Assets) panel on a guided make (Trello KvfVxVhb).
//
// The FOURTEENTH sibling chrome module, NOT uniformly wired: it ALLOW-LISTS `body[data-surface]` to
// exactly `guided-make` and returns before touching anything anywhere else. It then requires BOTH
// keys the server sets from its one boolean `gmAllowUploads` (features.assets AND the activity's
// `guidedMake.allowUploads`): `#guided-make-config` carrying `allowUploads: true`, and the
// server-rendered `#runner-assets` button + `#assets-modal` dialog (the template is authoritative,
// the config is the second key). Only then does it call the SHARED `wireAssets` — the very panel
// the assignment, challenge and editor surfaces use, unchanged: upload through
// `editorApi.uploadAsset` (POST /api/users/assets), then `core.setAssets`.
//
// AMENDMENT (working-copy asset save): it hands `wireAssets` a small WRAPPER api whose
// `saveAssets` PUTs ONLY the asset list to the dedicated `PUT /api/projects/{id}/working-assets`
// (`project.saveWorkingAssets`), never `editorApi.saveAssets`' `PUT …/code` — that route is
// owner-only (`canEdit`; a course working copy has no `_owner`, so it 403'd as "Upload failed.")
// and it also writes `code`, which would overwrite the working copy's base with the editor's
// files (the student's work lives in a Draft). Every other api member is the real editor-api's.
//
// Wired LATE from main.js, after `wireVersions` inside `loadProject().then()`, because
// `wireAssets` needs `core` and the load `payload` (its seeded asset list). So it is never wired on
// a LOCKED plan page — main.js returns before reaching it. editor-core.js / editor-api.js,
// guided-make-chrome.js and the runner contract are unchanged (assets-panel.js now owns the wrapper). Never throws.

import { wireAssets, makeWorkingAssetsApi } from './assets-panel.js';

var ALLOWED_SURFACES = ['guided-make'];

function readAllowUploads(doc) {
  try {
    var node = doc.getElementById('guided-make-config');
    if (!node) { return false; }
    var cfg = JSON.parse(node.textContent || '{}');
    return !!cfg && cfg.allowUploads === true;
  } catch (e) { return false; }
}

// The wrapper api now lives in assets-panel.js (shared by assignment, challenge and guided-make).
export { makeWorkingAssetsApi };

/**
 * Wire the guided-make Images & sounds panel when (and only when) the page is a guided make with
 * uploads switched on. `ctx` = { core, payload, trinketId, editorApi, doc }. The optional `wire`
 * argument is a TEST SEAM (defaults to the shared `wireAssets`). Returns true when it wired.
 */
export function wireGuidedMakeUploads(ctx, wire) {
  try {
    var doc = ctx && ctx.doc;
    if (!doc || !doc.body || !ctx.core) { return false; }
    var surface = doc.body.getAttribute('data-surface');
    if (ALLOWED_SURFACES.indexOf(surface) === -1) { return false; }
    if (!readAllowUploads(doc)) { return false; }
    if (!doc.getElementById('runner-assets') || !doc.getElementById('assets-modal')) { return false; }
    (typeof wire === 'function' ? wire : wireAssets)({
      core: ctx.core,
      payload: ctx.payload,
      trinketId: ctx.trinketId,
      editorApi: makeWorkingAssetsApi(ctx.editorApi),
      doc: doc
    });
    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
}
